import { Link } from 'react-router-dom';
import React from 'react';
import { Card } from 'react-bootstrap';
import { ChevronRight } from 'lucide-react';

const CardsBranches = ({
  CardLabel,
  totalManagers,
  totalAssistants,
  totalPods,
  PageRoute
}) => {
  return (
    <Card className="border-0 rounded-16 bg-brand-light card-branches-new">
      <Card.Body className="p-20">
        {/* Header with building icon and title */}
        <div className="d-flex align-items-center header mb-9">
          <div className="icon-wrapper icon-building">
            <img
              src="/assets/icons/branches.svg"
              alt="Building"
              className="icon-masked"
              width="16"
              height="16"
            />
          </div>
          <Link to={PageRoute} className="text-decoration-none"><h5 className="text-20 fw-700 text-navy mb-0">{CardLabel}</h5></Link>
        </div>

        {/* Stats section */}
        <div className="stats-section mb-24">
          {/* Managers */}
          <div className="stat-item">
            <div className="icon-wrapper icon-gray">
              <img
                src="/assets/icons/managers.svg"
                alt="Managers"
                className="icon-masked"
                width="16"
                height="16"
              />
            </div>
            <span className="text-base font-normal text-secondary">Managers: {totalManagers?.toString().padStart(2, '0')}</span>
          </div>

          {/* Assistants */}
          <div className="stat-item">
            <div className="icon-wrapper icon-gray">
              <img
                src="/assets/icons/assistants.svg"
                alt="Assistants"
                className="icon-masked"
                width="16"
                height="16"
              />
            </div>
            <span className="text-base font-normal text-secondary">Assistant: {totalAssistants?.toString().padStart(2, '0')}</span>
          </div>

          {/* Pods/Teams */}
          <div className="stat-item">
            <div className="icon-wrapper icon-gray">
              <img
                src="/assets/icons/teams.svg"
                alt="Teams"
                className="icon-masked"
                width="16"
                height="16"
              />
            </div>
            <span className="text-base font-normal text-secondary">Pods/Teams: {totalPods?.toString().padStart(2, '0')}</span>
          </div>
        </div>

        {/* View Details Button */}
        <Link to={PageRoute} className="text-decoration-none">
          <div className="view-details-btn d-inline-flex align-items-center">
            <span className="text-16 fw-700 text-brand">View Details</span>
            <ChevronRight size={16} className="text-brand ms-1" />
          </div>
        </Link>
      </Card.Body>
    </Card>
  );
};

export default CardsBranches;
